// Returns the browser "<Name>" parsed from a User-Agent string (e.g. "Edge"),
// without any version token.
// Order matters: Chromium-based browsers (Edge, Opera) also put "Chrome" in their UA,
// so they must be matched before the generic Chrome check.
const BROWSERS = [
  { name: 'Edge', pattern: /edg(?:e|a|ios)?\//i },
  { name: 'Opera', pattern: /(?:opr|opios|opera)\//i },
  { name: 'Firefox', pattern: /(?:firefox|fxios)\//i },
  { name: 'Chrome', pattern: /(?:chrome|chromium|crios)\//i },
  { name: 'Safari', pattern: /version\/[\d.]+.*safari/i },
];

/**
 * Identifies the browser name from a user-agent string for online-time reporting. Matches the known browser patterns ordered so Edge and Opera are recognised before Chrome, falls back to name-only regex checks, and finally to an unknown label. No version token is returned.
 *
 * @param userAgent - Raw user-agent string to inspect.
 * @returns A browser name label.
 */
const detectBrowser = (userAgent: string) => {
  if (!userAgent) return 'Unknown Browser';

  const matched = BROWSERS.find(({ pattern }) => pattern.test(userAgent));
  if (matched) return matched.name;

  // Version token missing or non-standard: fall back to name-only detection.
  if (/edg/i.test(userAgent)) return 'Edge';
  if (/opr|opera/i.test(userAgent)) return 'Opera';
  if (/firefox|fxios/i.test(userAgent)) return 'Firefox';
  if (/chrome|chromium|crios/i.test(userAgent)) return 'Chrome';
  if (/safari/i.test(userAgent)) return 'Safari';
  return 'Unknown Browser';
};

export default detectBrowser;
